var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#d9ebc7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4752 10.1918C16.0943 10.5728 15.9038 10.7633 15.6671 10.7633C15.4304 10.7633 15.2399 10.5728 14.859 10.1918L13.8085 9.14142C13.4276 8.76046 13.2371 8.56999 13.2371 8.33329C13.2371 8.0966 13.4276 7.90612 13.8085 7.52517L13.859 7.47475C14.2399 7.0938 14.4304 6.90332 14.6671 6.90332C14.9038 6.90332 15.0943 7.0938 15.4752 7.47475L16.5256 8.52517C16.9066 8.90612 17.0971 9.0966 17.0971 9.33329C17.0971 9.56999 16.9066 9.76046 16.5256 10.1414L16.4752 10.1918ZM7.80985 17.3334C7.2711 17.3334 7.00173 17.3334 6.83436 17.166C6.66699 16.9987 6.66699 16.7293 6.66699 16.1905V15.1401C6.66699 14.9065 6.66699 14.7897 6.71049 14.6847C6.75399 14.5797 6.83657 14.4971 7.00173 14.332L11.5255 9.80818C11.9065 9.42722 12.097 9.23675 12.3337 9.23675C12.5704 9.23675 12.7608 9.42722 13.1418 9.80818L14.1922 10.8586C14.5732 11.2395 14.7636 11.43 14.7636 11.6667C14.7636 11.9034 14.5732 12.0939 14.1922 12.4748L9.66839 16.9987C9.50323 17.1638 9.42065 17.2464 9.31564 17.2899C9.21063 17.3334 9.09384 17.3334 8.86027 17.3334H7.80985Z",
    fill: "#81BC45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditButton);
export default __webpack_public_path__ + "static/media/edit_button.72cf4a32c52efc7dd3c52b6c3adf47c4.svg";
export { ForwardRef as ReactComponent };